import React from "react";
import clsx from "clsx";

import BoxSelectForm from "../BoxSelectForm";
import { IStudentGearBox } from "../../state";

import styles from "./BoxToggle.module.scss";

export interface BoxToggleProps {
  isBoxToggleOn: boolean;
  showBoxDropdown: boolean;
  selectedBox: IStudentGearBox | undefined;
  gearBoxes: IStudentGearBox[];
  selected_box_id: number | null;
  toggleButtonRef: React.RefObject<HTMLButtonElement>;
  selectedNameRef: React.RefObject<HTMLButtonElement>;
  boxDropdownRef: React.RefObject<HTMLDivElement>;
  onToggle: () => void;
  onToggleDropdown: () => void;
  onSelectBox: (args: { [key: string]: any }) => void;
}

const BoxToggle: React.FC<BoxToggleProps> = ({
  isBoxToggleOn,
  showBoxDropdown,
  selectedBox,
  gearBoxes,
  selected_box_id,
  toggleButtonRef,
  selectedNameRef,
  boxDropdownRef,
  onToggle,
  onToggleDropdown,
  onSelectBox,
}) => {
  if (!gearBoxes || gearBoxes.length === 0) {
    return null;
  }

  return (
    <div className={styles.boxToggleWrapper}>
      <div className={styles.boxToggleHeader}>
        <button
          ref={toggleButtonRef}
          className={clsx(styles.toggleSwitch, {
            [styles.toggleSwitchOn]: isBoxToggleOn,
          })}
          onClick={onToggle}
          type="button"
        >
          <span className={styles.toggleKnob} />
        </button>
        {isBoxToggleOn && selectedBox ? (
          <button
            ref={selectedNameRef}
            className={styles.boxToggleSelectedName}
            type="button"
            onClick={onToggleDropdown}
          >
            {selectedBox.title}
          </button>
        ) : (
          <span className={styles.boxToggleLabel}>BOXに提出</span>
        )}
      </div>
      {showBoxDropdown && (
        <div ref={boxDropdownRef} className={styles.boxDropdownArea}>
          <BoxSelectForm
            isOpen={true}
            gearBoxes={gearBoxes}
            selected_box_id={selected_box_id}
            update={onSelectBox}
          />
        </div>
      )}
    </div>
  );
};

export default BoxToggle;
